import React from 'react';
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  TextField,
} from '@mui/material';

const GoalSelectionSection = ({
  isFirstSectionComplete,
  goalAssociatedWithBehavior,
  handleGoalAssociatedWithBehavior,
  selectedGoalIds,
  handleGoalIdChange,
  goalsDropDown,
  selectCategory,
  handleSelectCategory,
  selectedBehaviorIds,
  handleBehaviorIdChange,
  behaviorsOnly,
  selectedSkillIds,
  handleSkillIdChange,
  skillsOnly,
  otherInputValue,
  setOtherInputValue,
}) => (
  <>
    <Typography
      sx={{
        marginBottom: '8px',
        color: !isFirstSectionComplete ? 'gray' : '#9291F0',
      }}
      gutterBottom={isFirstSectionComplete}
    >
      * Is there a goal associated with this video?
    </Typography>
    <RadioGroup
      row
      name='goalAssociatedWithBehavior'
      value={goalAssociatedWithBehavior.toString()}
      onChange={handleGoalAssociatedWithBehavior}
    >
      <FormControlLabel
        value='true'
        control={<Radio />}
        label='Yes'
        disabled={!isFirstSectionComplete}
      />
      <FormControlLabel
        value='false'
        control={<Radio />}
        label='No'
        disabled={!isFirstSectionComplete}
      />
    </RadioGroup>
    {goalAssociatedWithBehavior && (
      <>
        <Typography
          sx={{ color: !isFirstSectionComplete ? 'gray' : '#9291F0' }}
          gutterBottom={isFirstSectionComplete}
        >
          * Select Goals(s)
        </Typography>
        <FormControl fullWidth>
          <Select
            labelId='goal-select-label'
            multiple
            value={selectedGoalIds}
            onChange={handleGoalIdChange}
            renderValue={(selected) =>
              goalsDropDown
                .filter((goal) => selected.includes(goal.id))
                .map(
                  (goal) => goal?.info?.GoalDetails?.GoalTitle || 'Unnamed Goal'
                )
                .join(', ')
            }
          >
            {goalsDropDown.map((goal) => (
              <MenuItem key={goal.id} value={goal.id}>
                <Checkbox checked={selectedGoalIds.includes(goal.id)} />
                <ListItemText
                  primary={goal?.info?.GoalDetails?.GoalTitle || 'Unnamed Goal'}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    )}
    {!goalAssociatedWithBehavior && (
      <>
        <Typography
          sx={{ color: !isFirstSectionComplete ? 'gray' : '#9291F0' }}
          gutterBottom={isFirstSectionComplete}
        >
          * Select Category
        </Typography>
        <RadioGroup
          row
          name='selectCategory'
          value={selectCategory}
          onChange={handleSelectCategory}
        >
          <FormControlLabel
            value='Behavior'
            control={<Radio />}
            label='Behavior'
            disabled={!isFirstSectionComplete}
          />
          <FormControlLabel
            value='Skill Acquisition'
            control={<Radio />}
            label='Skill Acquisition'
            disabled={!isFirstSectionComplete}
          />
          <FormControlLabel
            value='Other'
            control={<Radio />}
            label='Other'
            disabled={!isFirstSectionComplete}
          />
          <FormControlLabel
            value='None'
            control={<Radio />}
            label='None'
            disabled={!isFirstSectionComplete}
          />
        </RadioGroup>
      </>
    )}
    {selectCategory === 'Behavior' && (
      <>
        <Typography
          sx={{ color: !isFirstSectionComplete ? 'gray' : '#9291F0' }}
          gutterBottom={isFirstSectionComplete}
        >
          * Select Behavior(s)
        </Typography>
        <FormControl fullWidth>
          <Select
            labelId='behavior-select-label'
            multiple
            value={selectedBehaviorIds}
            onChange={handleBehaviorIdChange}
            renderValue={(selected) =>
              behaviorsOnly
                .filter((b) => selected.includes(b.id))
                .map(
                  (b) =>
                    b?.info?.BehaviorDetails?.Type?.BehaviorName ||
                    'Unnamed Behavior'
                )
                .join(', ')
            }
          >
            {behaviorsOnly.map((b) => (
              <MenuItem key={b.id} value={b.id}>
                <Checkbox checked={selectedBehaviorIds.includes(b.id)} />
                <ListItemText
                  primary={
                    b?.info?.BehaviorDetails?.Type?.BehaviorName ||
                    'Unnamed Behavior'
                  }
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    )}
    {selectCategory === 'Skill Acquisition' && (
      <>
        <Typography
          sx={{ color: !isFirstSectionComplete ? 'gray' : '#9291F0' }}
          gutterBottom={isFirstSectionComplete}
        >
          * Select Skill Acquisition(s)
        </Typography>
        <FormControl fullWidth>
          <Select
            labelId='skill-select-label'
            multiple
            value={selectedSkillIds}
            onChange={handleSkillIdChange}
            renderValue={(selected) =>
              skillsOnly
                .filter((s) => selected.includes(s.id))
                .map(
                  (s) =>
                    s?.info?.BehaviorDetails?.Type?.SkillName || 'Unnamed Skill'
                )
                .join(', ')
            }
          >
            {skillsOnly.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                <Checkbox checked={selectedSkillIds.includes(s.id)} />
                <ListItemText
                  primary={
                    s?.info?.BehaviorDetails?.Type?.SkillName || 'Unnamed Skill'
                  }
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    )}
    {selectCategory === 'Other' && (
      <>
        <Typography
          sx={{ color: !isFirstSectionComplete ? 'gray' : '#9291F0' }}
          gutterBottom={isFirstSectionComplete}
        >
          * Enter Other
        </Typography>
        <TextField
          fullWidth
          label='Other'
          value={otherInputValue}
          onChange={(e) => setOtherInputValue(e.target.value)}
        />
      </>
    )}
  </>
);

export default GoalSelectionSection;
